(function(){
var app=document.getElementById('gs-app');if(!app)return;
try{var tb=document.querySelector('.gs-top b');if(tb)tb.textContent='GLOW SCAN  v40'}catch(e){}
var open={};
function label(t){return /Add three photos/.test(t)?'Photo tips and privacy':/Reading your photos/.test(t)?'What we measured':/Where should we send/.test(t)?'Payment, promise and privacy':'Why we ask'}
var busy=false;
function tick(){if(busy)return;busy=true;try{
 var h=app.querySelector(':scope>h2');if(!h){busy=false;return}
 var t=h.textContent,key=t.slice(0,60),help=[];
 [].slice.call(app.children).forEach(function(el){
  if(el.tagName==='P'&&!/(^|\s)(pm|err|stage|pc|gs-unlock|g40-sub|gs-myerr)(\s|$)/.test(el.className)&&el.id!=='gs-unlock'){
   if(el.textContent.trim().length<=28)el.classList.add('g40-sub');else help.push(el)}
 });
 app.querySelectorAll('.gs-pnote,ul.tips,.gs-tb,.gs-why,.g8-pay,.chips').forEach(function(el){if(!el.closest('.g40-more'))help.push(el)});
 app.querySelectorAll('p').forEach(function(el){if(/15 minutes later/.test(el.textContent))el.textContent='We email you right away. Your full report and app access arrive within about 2 hours.'});
 var wa=app.querySelector('.gs-wa span');if(wa&&!wa.dataset.g40){wa.dataset.g40=1;wa.textContent='Also send me updates on WhatsApp (optional)'}
 if(help.length){
  var box=app.querySelector(':scope>.g40-more'),btn=app.querySelector(':scope>.g40-i');
  if(!box){btn=document.createElement('button');btn.type='button';btn.className='g40-i';btn.textContent=label(t);btn.setAttribute('aria-expanded',open[key]?'true':'false');
   box=document.createElement('div');box.className='g40-more';box.id='g40-more';btn.setAttribute('aria-controls','g40-more');if(!open[key])box.hidden=true;
   btn.onclick=function(){var o=box.hidden;box.hidden=!o;btn.setAttribute('aria-expanded',o?'true':'false');open[key]=o};
   var after=h.nextElementSibling&&h.nextElementSibling.classList.contains('g40-sub')?h.nextElementSibling:h;
   after.insertAdjacentElement('afterend',btn);btn.insertAdjacentElement('afterend',box)}
  help.forEach(function(el){box.appendChild(el)})}
}catch(e){}busy=false}
var q=0;new MutationObserver(function(){if(q)return;q=1;setTimeout(function(){q=0;tick()},90)}).observe(app,{childList:true,subtree:true});tick();
})();
